import { Role } from './accounts/account.contractparts';

export type Dictionary<T = any> = { [key: string]: T }

export type TypeMap<TFields = {}, TValues = any> = {
	[Property in keyof TFields]?: TValues;
};

export const rateLimitSymbol: symbol = Symbol('__rateLimit__');

export function RateLimit(config: RateLimitConfig): Function {
	return (target: new () => any) => {
		(target as any)[rateLimitSymbol] = config;
	};
}

export interface RateLimitConfig {
	perSecond?: number,
	perMinute?: number,
	ifHasRole?: Role,
}
